// 17个关键点名称定义
export const KEYPOINT_NAMES = [
  'NOSE',
  'LEFT_EYE',
  'RIGHT_EYE',
  'LEFT_EAR',
  'RIGHT_EAR',
  'LEFT_SHOULDER',
  'RIGHT_SHOULDER',
  'LEFT_ELBOW',
  'RIGHT_ELBOW',
  'LEFT_WRIST',
  'RIGHT_WRIST',
  'LEFT_HIP',
  'RIGHT_HIP',
  'LEFT_KNEE',
  'RIGHT_KNEE',
  'LEFT_ANKLE',
  'RIGHT_ANKLE',
];

// 关键点中文名映射
export const KEYPOINT_LABELS = {
  NOSE: '鼻子',
  LEFT_EYE: '左眼',
  RIGHT_EYE: '右眼',
  LEFT_EAR: '左耳',
  RIGHT_EAR: '右耳',
  LEFT_SHOULDER: '左肩',
  RIGHT_SHOULDER: '右肩',
  LEFT_ELBOW: '左肘',
  RIGHT_ELBOW: '右肘',
  LEFT_WRIST: '左腕',
  RIGHT_WRIST: '右腕',
  LEFT_HIP: '左胯',
  RIGHT_HIP: '右胯',
  LEFT_KNEE: '左膝',
  RIGHT_KNEE: '右膝',
  LEFT_ANKLE: '左踝',
  RIGHT_ANKLE: '右踝',
};

// 骨骼连接定义：[起点索引, 终点索引, 骨骼名称]
export const SKELETON_BONES = [
  [5, 6, 'LEFT_SHOULDER-RIGHT_SHOULDER'],
  [5, 11, 'LEFT_SHOULDER-LEFT_HIP'],
  [6, 12, 'RIGHT_SHOULDER-RIGHT_HIP'],
  [11, 12, 'LEFT_HIP-RIGHT_HIP'],
  [5, 7, 'LEFT_SHOULDER-LEFT_ELBOW'],
  [7, 9, 'LEFT_ELBOW-LEFT_WRIST'],
  [6, 8, 'RIGHT_SHOULDER-RIGHT_ELBOW'],
  [8, 10, 'RIGHT_ELBOW-RIGHT_WRIST'],
  [11, 13, 'LEFT_HIP-LEFT_KNEE'],
  [13, 15, 'LEFT_KNEE-LEFT_ANKLE'],
  [12, 14, 'RIGHT_HIP-RIGHT_KNEE'],
  [14, 16, 'RIGHT_KNEE-RIGHT_ANKLE'],
];

// 骨骼中文名映射
export const BONE_LABELS = {
  'LEFT_SHOULDER-RIGHT_SHOULDER': '左肩-右肩',
  'LEFT_SHOULDER-LEFT_HIP': '左肩-左胯',
  'RIGHT_SHOULDER-RIGHT_HIP': '右肩-右胯',
  'LEFT_HIP-RIGHT_HIP': '左胯-右胯',
  'LEFT_SHOULDER-LEFT_ELBOW': '左肩-左肘',
  'LEFT_ELBOW-LEFT_WRIST': '左肘-左腕',
  'RIGHT_SHOULDER-RIGHT_ELBOW': '右肩-右肘',
  'RIGHT_ELBOW-RIGHT_WRIST': '右肘-右腕',
  'LEFT_HIP-LEFT_KNEE': '左胯-左膝',
  'LEFT_KNEE-LEFT_ANKLE': '左膝-左踝',
  'RIGHT_HIP-RIGHT_KNEE': '右胯-右膝',
  'RIGHT_KNEE-RIGHT_ANKLE': '右膝-右踝',
};

// 头部绘制：利用双耳中心作为头部中心
export const HEAD_KEYPOINTS = {
  leftEar: 3,
  rightEar: 4,
  nose: 0,
};

// 身体中线：头 -> 颈 -> 胯
export const BODY_SPINE = {
  neck: { leftShoulder: 5, rightShoulder: 6 },
  hip: { leftHip: 11, rightHip: 12 },
};
